import * as React from "react";
import { Button, Field, Input, Popover, PopoverSurface, PopoverTrigger, makeStyles } from "@fluentui/react-components";
import { Settings24Regular } from "@fluentui/react-icons";
import { FilteredComboBox } from "../shared/FilteredCombobox.js";

const useStyles = makeStyles({
  surface: {
    minWidth: "320px",
    display: "grid",
    gap: "10px",
  },
});

export interface JoinSettingsPopoverControlProps {
  alias: string;
  linkType: string;
  linkTypeOptions: string[];
  relationOptions?: Array<[string, string]>;
  relationKey?: string;
  onAliasChange: (value: string) => void;
  onLinkTypeChange: (value: string) => void;
  onRelationChange?: (value: string) => void;
}

export function JoinSettingsPopoverControl({
  alias,
  linkType,
  linkTypeOptions,
  relationOptions,
  relationKey,
  onAliasChange,
  onLinkTypeChange,
  onRelationChange,
}: JoinSettingsPopoverControlProps): JSX.Element {
  const styles = useStyles();

  return (
    <Popover positioning="below-end">
      <PopoverTrigger disableButtonEnhancement>
        <Button appearance="subtle" icon={<Settings24Regular />} aria-label="Settings" title="Settings" />
      </PopoverTrigger>

      <PopoverSurface className={styles.surface}>
        {relationOptions && onRelationChange ? (
          <Field label="Relation">
            <FilteredComboBox
              options={relationOptions}
              selectedOption={relationKey}
              onValueChange={onRelationChange}
            />
          </Field>
        ) : null}

        <Field label="Alias">
          <Input value={alias} onChange={(_event, data) => onAliasChange(data.value)} />
        </Field>

        <Field label="Link type">
          <FilteredComboBox
            options={linkTypeOptions.map((item) => [item, item] as [string, string])}
            selectedOption={linkType}
            onValueChange={onLinkTypeChange}
          />
        </Field>
      </PopoverSurface>
    </Popover>
  );
}